import React from "react";
import ReactGA from "react-ga";
import ReactDOM from "react-dom";
import { browserHistory } from "react-router";
import { syncHistoryWithStore } from "react-router-redux";

import intercomBoot from "./lib/intercomBoot";
import { initAuth } from "./core/auth";
import configureStore from "./core/store";
import Root from "./views/root";

ReactGA.initialize("UA-118831712-1");
window.Raven.config(
  "https://fefd3d36497c4adbad2574e5ecd60154@sentry.io/1202240"
).install(); // eslint-disable-line no-undef

const store = configureStore();
const syncedHistory = syncHistoryWithStore(browserHistory, store);
const rootElement = document.getElementById("root");

function render(Root) {
  ReactDOM.render(<Root history={syncedHistory} store={store} />, rootElement);
}

render(Root);

initAuth(store.dispatch)
  .then((user) => {
    // intercomBoot(user);
  })
  .catch((error) => {
    Raven.captureException(error); // eslint-disable-line no-undef
    console.error(error); // eslint-disable-line no-console
  });



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/